import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "m-6 text-lg text-center font-semibold text-gray-800"
};
const _hoisted_2 = {
  "data-cy": "table-client"
};
const _hoisted_3 = {
  "data-cy": "table-matter"
};
const _hoisted_4 = {
  "data-cy": "table-description"
};
const _hoisted_5 = {
  "data-cy": "table-amount"
};
const _hoisted_6 = {
  "data-cy": "table-billed"
};
const _hoisted_7 = {
  "data-cy": "table-check-number"
};
const _hoisted_8 = {
  class: "text-body-1 font-weight-bold"
};
const _hoisted_9 = {
  class: "print:hidden"
};
const _hoisted_10 = ["colspan"];
const _hoisted_11 = {
  class: "border-t-sm"
};
import LlTooltip from '@/components/LlTooltip.vue';
import { ref, reactive, watch } from 'vue';
import LlSelect from '@/components/LlSelect.vue';
import ExpenseService from '@/services/ExpenseService';
import { formatCurrency, getShortDateString } from '@/services/utils';
export default {
  __name: 'ExpenseListTable',
  props: {
    expenses: {
      type: Array,
      required: false
    },
    request: {
      type: Object,
      required: false
    },
    showType: {
      type: Boolean,
      required: true
    },
    me: {
      type: Object,
      required: true
    },
    total: {
      type: Number,
      required: false
    },
    vendorsList: {
      type: Array,
      required: false
    },
    leanLawApi: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    }
  },
  emits: ['editExpense', 'sort', 'viewAttachments'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const vm = reactive({
      sortBy: [{
        key: props.request.orderby,
        order: props.request.order
      }]
    });
    watch(() => vm.sortBy, () => {
      props.request.orderby = vm.sortBy[0]?.key;
      props.request.order = vm.sortBy[0]?.order;
      emit('sort', props.request.orderby, props.request.order);
    });
    const headers = ref([{
      title: '',
      value: 'accounting',
      sortable: false
    }, {
      title: 'Date',
      value: 'date',
      sortable: true
    }]);
    if (props.showType) {
      headers.value.push({
        title: 'Type',
        value: 'type',
        sortable: true,
        align: 'start'
      });
    }
    headers.value.push({
      title: 'User',
      value: 'user',
      sortable: true
    });
    if (!props.request.client) {
      headers.value.push({
        title: 'Client',
        value: 'client',
        sortable: true
      });
    }
    headers.value.push({
      title: props.me.terms?.Matter,
      value: 'matter',
      sortable: true
    }, {
      title: 'Description',
      value: 'description',
      sortable: true
    });
    if (props.me.features?.importcsv) {
      headers.value.push({
        title: 'Vendor',
        value: 'vendor',
        sortable: true
      });
    }
    if (props.me.company.settings?.codes?.ledes) {
      headers.value.push({
        title: 'Code',
        value: 'code',
        sortable: true
      });
    }
    headers.value.push({
      title: 'Amount',
      value: 'amount',
      sortable: true
    }, {
      title: 'Billed',
      value: 'billed',
      sortable: true
    });
    if (props.me.company.settings?.expenses?.includeCheckNumberInDescription) {
      headers.value.push({
        title: 'Check#',
        value: 'checkNumber',
        sortable: true
      });
    }
    if (props.me.features?.expenseAttachments) {
      headers.value.push({
        title: 'Attachment',
        value: 'attachments',
        sortable: false,
        align: 'center'
      });
    }
    if (props.me.company.settings?.labels?.customFlag) {
      headers.value.push({
        title: props.me.company.settings?.labels?.customFlag,
        value: 'customFlag',
        sortable: true
      });
    }
    headers.value.push({
      title: '',
      value: 'actions',
      sortable: false
    });
    const openQuickbooks = expense => {
      window.open(expense.accounting.href, '_blank');
    };
    const editExpense = (event, row) => {
      if (!row) {
        return;
      }
      emit('editExpense', row.item);
    };
    const saveExpense = async item => {
      const expense = await new ExpenseService(props.leanLawApi, props.userService, props.alerts).get(item.id);
      expense.vendor = item.vendor;
      props.leanLawApi.updateExpense({
        id: item.id,
        body: expense
      }).then(async () => {
        props.alerts.success('Expense was updated successfully');
      }).catch(e => props.alerts.error(e));
    };
    return (_ctx, _cache) => {
      const _component_v_img = _resolveComponent("v-img");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_list_item_title = _resolveComponent("v-list-item-title");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_menu = _resolveComponent("v-menu");
      const _component_v_data_table = _resolveComponent("v-data-table");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_container = _resolveComponent("v-container");
      return _openBlock(), _createBlock(_component_v_container, {
        fluid: "",
        class: "py-2 px-2"
      }, {
        default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_1, " No Expenses match the filters ", 512), [[_vShow, !__props.expenses.length]]), _withDirectives(_createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_data_table, {
            "items-per-page": __props.request.limit,
            "onUpdate:itemsPerPage": _cache[2] || (_cache[2] = $event => __props.request.limit = $event),
            headers: headers.value,
            items: __props.expenses,
            "must-sort": true,
            "sort-by": vm.sortBy,
            "onUpdate:sortBy": _cache[3] || (_cache[3] = $event => vm.sortBy = $event),
            "onClick:row": editExpense,
            "hide-default-footer": "",
            "header-props": {
              class: 'bg-grey-lighten-5 text-uppercase'
            },
            "data-cy": "expense-table"
          }, {
            "header.type": _withCtx(() => [_cache[5] || (_cache[5] = _createElementVNode("span", {
              class: "pr-2"
            }, "Type", -1)), _createVNode(LlTooltip, {
              icon: "help"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("LeanLaw: Created in LeanLaw; ", -1), _createElementVNode("br", null, null, -1), _createTextVNode(" Bill/Expense: Created in QuickBooks", -1)]))]),
              _: 1
            })]),
            [`item.accounting`]: _withCtx(({
              item
            }) => [_withDirectives(_createVNode(_component_v_img, {
              class: "no-print",
              width: 10,
              cover: "",
              src: "/img/qb10x10.png"
            }, null, 512), [[_vShow, item.accounting]])]),
            [`item.date`]: _withCtx(({
              item
            }) => [_createTextVNode(_toDisplayString(_unref(getShortDateString)(item.date)), 1)]),
            [`item.attachments`]: _withCtx(({
              item
            }) => [_withDirectives(_createVNode(_component_v_icon, _mergeProps({
              onClick: [_withModifiers(editExpense, ["stop"]), _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop", "prevent"])), _withModifiers($event => _ctx.$emit('viewAttachments', item), ["prevent"])]
            }, props), {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("mdi-paperclip", -1)]))]),
              _: 1
            }, 16, ["onClick"]), [[_vShow, item.attachments.length]])]),
            [`item.client`]: _withCtx(({
              item
            }) => [_createElementVNode("span", _hoisted_2, _toDisplayString(item.client), 1)]),
            [`item.matter`]: _withCtx(({
              item
            }) => [_createElementVNode("span", _hoisted_3, _toDisplayString(item.matter), 1)]),
            [`item.description`]: _withCtx(({
              item
            }) => [_createElementVNode("span", _hoisted_4, _toDisplayString(item.description), 1)]),
            [`item.vendor`]: _withCtx(({
              item
            }) => [_createElementVNode("span", _mergeProps({
              "data-cy": "table-vendor",
              onClick: [_withModifiers(editExpense, ["stop"]), _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop", "prevent"]))]
            }, props), [item.vendor ? (_openBlock(), _createBlock(LlSelect, {
              key: 0,
              modelValue: item.vendor,
              "onUpdate:modelValue": [$event => item.vendor = $event, $event => saveExpense(item)],
              items: __props.vendorsList,
              "item-title": item => item.displayName || item.name,
              "item-value": "id",
              density: "compact",
              class: "at-choose-client remove-outline",
              "return-object": "",
              variant: "underlined",
              "hide-details": "true",
              labelClass: "text-sm",
              isAutocomplete: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])) : _createCommentVNode("", true)], 16)]),
            [`item.amount`]: _withCtx(({
              item
            }) => [_createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatCurrency)(item.amount)), 1)]),
            [`item.customFlag`]: _withCtx(({
              item
            }) => [_createTextVNode(_toDisplayString(item.customFlag ? 'Yes' : 'No'), 1)]),
            [`item.billed`]: _withCtx(({
              item
            }) => [_createElementVNode("span", _hoisted_6, _toDisplayString(item.billed ? 'Yes' : 'No'), 1)]),
            [`item.checkNumber`]: _withCtx(({
              item
            }) => [_createElementVNode("span", _hoisted_7, _toDisplayString(item.checkNumber), 1)]),
            [`item.actions`]: _withCtx(({
              item
            }) => [_createVNode(_component_v_menu, {
              class: "no-print"
            }, {
              activator: _withCtx(({
                props
              }) => [_createVNode(_component_v_icon, _mergeProps(props, {
                class: "no-print"
              }), {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("mdi-dots-horizontal", -1)]))]),
                _: 1
              }, 16)]),
              default: _withCtx(() => [_createVNode(_component_v_list, null, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_v_list_item, {
                  onClick: $event => _ctx.$emit('editExpense', item)
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("Edit", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["onClick"]), [[_vShow, !item.billed]]), _withDirectives(_createVNode(_component_v_list_item, {
                  onClick: $event => _ctx.$emit('editExpense', item)
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("View", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["onClick"]), [[_vShow, item.billed]]), _withDirectives(_createVNode(_component_v_list_item, {
                  onClick: $event => openQuickbooks(item)
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("Open in QuickBooks", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["onClick"]), [[_vShow, item.accounting && __props.me.permissions?.expenses?.assign]])]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1024)]),
            "body.append": _withCtx(() => [_createElementVNode("tr", _hoisted_8, [_withDirectives(_createElementVNode("td", _hoisted_9, null, 512), [[_vShow, __props.showType]]), _createElementVNode("td", {
              colspan: 6 - (__props.request.client ? 1 : 0) - (__props.request.matter ? 1 : 0)
            }, " Total ", 8, _hoisted_10), _withDirectives(_createElementVNode("td", null, null, 512), [[_vShow, __props.me.company.settings?.codes?.ledes]]), _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formatCurrency)(__props.total)), 1), _cache[11] || (_cache[11] = _createElementVNode("td", null, null, -1)), _cache[12] || (_cache[12] = _createElementVNode("td", null, null, -1))])]),
            _: 2
          }, 1032, ["items-per-page", "headers", "items", "sort-by"])]),
          _: 1
        }, 512), [[_vShow, __props.expenses.length > 0]])]),
        _: 1
      });
    };
  }
};